import { useQuery } from "@tanstack/react-query";
import adminApiClient, { UpfrontPayment } from "../../api/admin";
import { PaymentsRange } from "../../views/Dashboard/components/PaymentsRangeFilter";

const useUpfrontPayments = (range: PaymentsRange) => {
  return useQuery<UpfrontPayment[]>({
    queryKey: ["upfrontPayments", range],
    queryFn: () => adminApiClient.getUpfrontPayments(range),
  });
};

export default useUpfrontPayments;
